var exports = {
  "x": "x93eb46d8--e9abc2--button",
  "q": "x93eb46d8--e9abc2--badge",
};

module.exports = exports;
